import React, { useState } from "react";
import CompetitorSelection from "./addProductCompetitor/CompetitorSelection";
import CategoriesSelection from "./addProductCompetitor/CategoriesSelection";
import UploadPdf from "./addProductCompetitor/UploadPdf";

function UploadCompetitor({ language, currentUser }) {
    const [subView, setSubView] = useState("menu");
    const [file, setFile] = useState(null);
    const [status, setStatus] = useState("");
    const [loading, setLoading] = useState(false);
    // { categoryId, categoryName, producerId, producerName }
    const [selection, setSelection] = useState(null);

    if (subView === "selection") {
        return (
            <CompetitorSelection
                language={language}
                currentUser={currentUser}
                onBack={() => setSubView("menu")}
                onNext={(sel) => {
                    setSelection(sel); // { producerId, producerName }
                    setSubView("categories");
                }}
            />
        );
    }

    if (subView === "categories") {
        return (
            <CategoriesSelection
                language={language}
                currentUser={currentUser}
                onBack={() => setSubView("selection")}
                onNext={(catSel) => {
                    // Merge category into existing competitor selection
                    setSelection((prev) => ({ ...prev, ...catSel }));
                    setSubView("pdf");
                }}
            />
        );
    }

    if (subView === "pdf") {
        return (
            <UploadPdf
                language={language}
                currentUser={currentUser}
                file={file}
                setFile={setFile}
                status={status}
                setStatus={setStatus}
                loading={loading}
                setLoading={setLoading}
                selection={selection}
                onBack={() => {
                    setSubView("categories");
                    setFile(null);
                    setStatus("");
                }}
                onDone={() => {
                    setSubView("menu");
                    setFile(null);
                    setStatus("");
                    setSelection(null);
                }}
            />
        );
    }

    // ── "menu" view ────────────────────────────────────────────────────────
    return (
        <div className="animate-slideUp flex justify-center">
            <div className="w-full max-w-3xl">
                <div className="grid grid-cols-1 gap-6">
                    <button
                        onClick={() => setSubView("selection")}
                        className="group bg-white border-2 border-gray-200 hover:border-red-500/50 rounded-2xl p-8 text-left transition-all duration-300 hover:shadow-xl hover:-translate-y-1 hover:ring-4 hover:ring-red-500/20 focus:outline-none"
                    >
                        <div className="w-16 h-16 bg-red-500/10 rounded-2xl flex items-center justify-center mb-5 text-red-500 group-hover:scale-110 transition-transform duration-300">
                            <svg
                                className="w-10 h-10"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={1.5}
                                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                />
                            </svg>
                        </div>
                        <h3 className="text-lg font-bold text-gray-900 mb-2">
                            {language === "zh"
                                ? "上傳競品 PDF"
                                : "Upload Competitor Product PDF"}
                        </h3>
                        <p className="text-sm text-gray-500 leading-relaxed mb-4">
                            {language === "zh"
                                ? "上傳競品規格書 PDF，透過 AI 自動提取並建立競品資訊。"
                                : "Upload a competitor datasheet PDF to extract and create competitor product information using AI."}
                        </p>
                        <div className="inline-flex items-center gap-2 text-sm font-medium text-red-500">
                            {language === "zh" ? "開始" : "Get started"}
                            <svg
                                className="w-4 h-4 group-hover:translate-x-1 transition-transform"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9 5l7 7-7 7"
                                />
                            </svg>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default UploadCompetitor;
